import React from "react";
import Header from "../Header/Header";
import Heart from "../../assets/heart.png";
import calories from "../../assets/calories.png";
import hero_image from "../../assets/hero_image.png";
import hero_image_back from "../../assets/hero_image_back.png";
import "./Hero.css";
import { motion } from "framer-motion";
import NumberCounter from "number-counter";

const Hero = () => {
  const transition = { type: "spring", duration: 3 };
  const mobile = window.innerWidth <= 768 ? true : false;
  return (
    <div className="hero" id="home">
      <div className="blur hero-blur"></div>
      <div className="left-h">
        <Header />
        {/* the best ad  */}
        <div className="the-best-ad">
          <motion.div
            initial={{ left: mobile ? "178px" : "238px" }}
            whileInView={{ left: "8px" }}
            transition={{ ...transition, type: "tween" }}
          ></motion.div>
          <span>the best fitness club in the town</span>
        </div>

        {/* Hero heading  */}
        <div className="hero-text">
          <div>
            <span className="stroke-text">SHAPE</span>
            <span> YOUR</span>
          </div>

          <div>
            <span>IDEAL BODY</span>
          </div>

          <div>
            <span>
              In here we will help you to shape and build your ideal body and
              live your life to the fullest
            </span>
          </div>
        </div>

        {/* figures  */}
        <div className="figures">
          <div>
            <span>
              <NumberCounter end={140} start={100} delay="4" preFix="+" />
            </span>
            <span>expert coaches</span>
          </div>
          <div>
            <span>
              <NumberCounter end={98} start={0} delay="4" preFix="+" />
            </span>
            <span>customize plans</span>
          </div>
          <div>
            <span>
              <NumberCounter end={570} start={0} delay="4" preFix="+" />
            </span>
            <span>active members</span>
          </div>
        </div>
        <div className="hero-buttons">
          <buttons className="btn">Get Started</buttons>
          <buttons className="btn">Learn More</buttons>
        </div>
      </div>
      <div className="right-h">
        <button className="btn">Join Now</button>
        <motion.div
          initial={{ left: "238px" }}
          whileInView={{ left: "20px" }}
          transition={{ ...transition, type: "tween" }}
          className="heart-rate"
        >
          <img src={Heart} alt="" />
          <span>Heart Rate</span> <span>116 bpm</span>
        </motion.div>

        {/* hero images  */}
        <img src={hero_image} alt="" className="hero-image" />
        <motion.img
          initial={{ right: "10px" }}
          whileInView={{ right: "360px" }}
          transition={{ ...transition, type: "tween" }}
          src={hero_image_back}
          alt=""
          className="hero-image-back"
        />

        {/* calories  */}
        <motion.div
          initial={{ right: "5px" }}
          whileInView={{ right: "500px" }}
          transition={{ ...transition, type: "tween" }}
          className="calories"
        >
          <img src={calories} alt="" />
          <div>
            <span>Calories Burn</span>
            <span>2200</span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
